/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { fileName, excelSale } from '../../Miscellaneous/export';
import ReactExport from 'react-export-excel';
import c from '../../../../constant';
import useStore from '../../../../store';
import { mappingKhmerNumber } from '../../../../utils/market-development';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcel({ year = null, numColumns = 0, saleItems = [], natCatItems = [], ...props }) {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const { currentLang: lang } = useStore((state) => state.currentLang);

	useEffect(() => {
		const sales = saleItems?.map((cur) => excelData(cur?.saleReportType, cur?.saleProducts));
		const natcats = excelDataNatCat();
		setData([...sales, natcats]);
	}, [saleItems, natCatItems]);

	function excelDataNatCat() {
		let values = natCatItems?.cells?.map((values) => values?.map((valueType) => valueType?.value));
		let data = values?.map((value, i) => {
			let localValue = value;
			localValue.unshift(lang === 'kh' ? natCatItems?.provinces[i]?.name : natCatItems?.provinces[i]?.latinName);
			localValue.unshift(lang === 'kh' ? '' : '');
			return localValue;
		});

		let totalNatCat = natCatItems?.cells?.map((values) => values?.map((valueType) => valueType?.value));
		const totals = totalNatCat.reduce((acc, row) => {
			row.forEach((val, colIndex) => {
				acc[colIndex] = (acc[colIndex] || 0) + val;
			});
			return acc;
		}, []);

		data = [...data, ['', 'Total', ...totals]];

		return { name: 'NATCAT', data };
	}

	function excelData(saleReportType = null, saleProducts = []) {
		const generalNewPolicies = excelSale({
			headline: t('New Policy'),
			title: t('General Micro Insurance Business'),
			saleProducts: saleProducts?.filter((el) => el?.productLine?.type === 'General' && el?.policyType === 'New') || [],
			numColumns,
			total: t('Total'),
			lang,
		});
		const lifeNewPolicies = excelSale({
			title: t('Life Micro Insurance Business'),
			saleProducts: saleProducts?.filter((el) => el?.productLine?.type === 'Life' && el?.policyType === 'New') || [],
			numColumns,
			total: t('Total'),
			lang,
		});
		const generalRenewalPolicies = excelSale({
			headline: t('Renewal Policy'),
			title: t('General Micro Insurance Business'),
			saleProducts: saleProducts?.filter((el) => el?.productLine?.type === 'General' && el?.policyType === 'Renewal') || [],
			numColumns,
			total: t('Total'),
			lang,
		});
		const lifeRenewalPolicies = excelSale({
			title: t('Life Micro Insurance Business'),
			saleProducts: saleProducts?.filter((el) => el?.productLine?.type === 'Life' && el?.policyType === 'Renewal') || [],
			numColumns,
			total: t('Total'),
			lang,
		});
		return { name: saleReportType, data: [...generalNewPolicies, ...lifeNewPolicies, ...generalRenewalPolicies, ...lifeRenewalPolicies] };
	}

	return (
		<>
			<Box {...props}>
				<ExcelFile
					filename={fileName('Sale', 'Micro', null, null, year)}
					element={
						<>
							<Button
								isLoading={false}
								isDisabled={false}
								onClick={() => null}
								leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
								colorScheme="gray"
								variant="solid"
								size="sm"
								borderRadius={c.borderRadius}
								border="1px solid #bdc3c7"
							>
								{t('Export')}
							</Button>
						</>
					}
				>
					{data?.map((el, i) => {
						if (el?.name === 'NATCAT') {
							return (
								<ExcelSheet key={`natcat-${i}`} data={el?.data} name={t('NATCAT')}>
									<ExcelColumn label={t('Province/City')} value="1" />
									<ExcelColumn
										label={lang === 'kh' ? 'បុព្វលាភធានារ៉ាប់រងដុល (គ្រោះមហន្តរាយសម្រាប់ធានារ៉ាប់រងទូទៅ)' : 'Gross Premium (Nat Cat)'}
										value="2"
									/>
									<ExcelColumn
										label={lang === 'kh' ? 'ចំនួនបណ្ណសន្យារ៉ាប់រង (គ្រោះមហន្តរាយសម្រាប់ធានារ៉ាប់រងទូទៅ)' : 'Number of Policies (Nat Cat)'}
										value="3"
									/>
									<ExcelColumn
										label={
											lang === 'kh' ? 'ទឹកប្រាក់ដែលត្រូវបានធានារ៉ាប់រង (គ្រោះមហន្តរាយសម្រាប់ធានារ៉ាប់រងទូទៅ)' : 'Sum Insured (Nat Cat)'
										}
										value="4"
									/>
									<ExcelColumn
										label={
											lang === 'kh'
												? 'បុព្វលាភធានារ៉ាប់រងដុល (គ្រោះមហន្តរាយសម្រាប់ទ្រព្យសម្បត្តិ)'
												: 'Gross Premium (Nat Cat for Property and Casualty)'
										}
										value="5"
									/>
									<ExcelColumn
										label={
											lang === 'kh'
												? 'ចំនួនបណ្ណសន្យារ៉ាប់រង (គ្រោះមហន្តរាយសម្រាប់ទ្រព្យសម្បត្តិ)'
												: 'Number of Policies (Nat Cat for Property and Casualty)'
										}
										value="6"
									/>
									<ExcelColumn
										label={
											lang === 'kh'
												? 'ទឹកប្រាក់ដែលត្រូវបានធានារ៉ាប់រង (គ្រោះមហន្តរាយសម្រាប់កសិកម្ម)'
												: 'Sum Insured (Nat Cat for Property and Casualty)'
										}
										value="7"
									/>
									<ExcelColumn
										label={
											lang === 'kh' ? 'បុព្វលាភធានារ៉ាប់រងដុល (គ្រោះមហន្តរាយសម្រាប់កសិកម្ម)' : 'Gross Premium (Nat Cat for Agriculture)'
										}
										value="8"
									/>
									<ExcelColumn
										label={
											lang === 'kh'
												? 'ចំនួនបណ្ណសន្យារ៉ាប់រង (គ្រោះមហន្តរាយសម្រាប់កសិកម្ម)'
												: 'Number of Policies (Nat Cat for Agriculture)'
										}
										value="9"
									/>
									<ExcelColumn
										label={
											lang === 'kh'
												? 'ទឹកប្រាក់ដែលត្រូវបានធានារ៉ាប់រង (គ្រោះមហន្តរាយសម្រាប់កសិកម្ម)'
												: 'Sum Insured (Nat Cat for Agriculture)'
										}
										value="10"
									/>
								</ExcelSheet>
							);
						}
						return (
							<ExcelSheet key={i} data={el?.data} name={t(el?.name)}>
								<ExcelColumn label={t('Ordinal')} value="0" />
								<ExcelColumn label={t('Product Line')} value="1" />
								<ExcelColumn label={lang === 'kh' ? 'បុព្វលាភធានារ៉ាប់រងដុល (បណ្ណសន្យារ៉ាប់រង)' : 'Gross Premium (Policies)'} value="2" />
								<ExcelColumn label={lang === 'kh' ? 'ទឹកប្រាក់ធានារ៉ាប់រង (បណ្ណសន្យារ៉ាប់រង)' : 'Sum Insured (Policies)'} value="3" />
								<ExcelColumn label={lang === 'kh' ? 'ចំនួនបណ្ណសន្យារ៉ាប់រង (បណ្ណសន្យារ៉ាប់រង)' : 'Number of Policies (Policies)'} value="4" />
								<ExcelColumn
									label={lang === 'kh' ? 'ចំនួនដែលត្រូវបានធានា_ប្រុស (បណ្ណសន្យារ៉ាប់រង)' : 'Number of Insured_Male (Policies)'}
									value="5"
								/>
								<ExcelColumn
									label={lang === 'kh' ? 'ចំនួនដែលត្រូវបានធានា_ស្រី (បណ្ណសន្យារ៉ាប់រង)' : 'Number of Insured_Female (Policies)'}
									value="6"
								/>
								<ExcelColumn
									label={lang === 'kh' ? 'ចំនួនដែលត្រូវបានធានា_ឯកតាផ្សេង (បណ្ណសន្យារ៉ាប់រង)' : 'Number of Insured_Other Unit (Policies)'}
									value="7"
								/>
								<ExcelColumn label={lang === 'kh' ? 'ចំនួន (បណ្ណសន្យារ៉ាប់រងលុបចោល/បញ្ចប់)' : 'Number (Cancelled Policies)'} value="8" />
								<ExcelColumn
									label={lang === 'kh' ? 'បុព្វលាភធានារ៉ាប់រងដុល (បណ្ណសន្យារ៉ាប់រងលុបចោល/បញ្ចប់)' : 'Gross Premium (Cancelled Policies)'}
									value="9"
								/>
							</ExcelSheet>
						);
					})}
				</ExcelFile>
			</Box>
		</>
	);
}
